import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '51大赛吃瓜黑料网',
  url: 'http://ahljjx.cn/',
  description: '深度吃瓜爱好者聚集地，聚焦网红明星塌房现场、博主反差猛料及私密聊天记录流出。实时更新各类独家黑料与热门事件深扒。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://ahljjx.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '51大赛吃瓜黑料网 - 首页',
  description: '51大赛吃瓜黑料网首页，最新网红塌房、明星爆料、私密聊天记录泄露、反差视频曝光，每日大赛实时追踪。',
  url: 'http://ahljjx.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '51大赛吃瓜黑料网',
    url: 'http://ahljjx.cn/',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}